import React, { useState, useRef, useContext, useEffect} from 'react'
import { Video } from './VideoUploadService'
import { LoaderContext } from '../../../context/loader-context'
import VideoContainer from './components/VideoContainer'
import './PaxVideoUploader.css'
import { NotificationManager } from 'react-notifications'
import UploadExceptionList from './utils/uploadExceptions'
import fetchMSSQLHook from '../../../hooks/fetchMSSQL-hook'

export default function PaxVideoUploader() {
  const [videos, setVideos] = useState([]);
  const inputRef = useRef();
  const { fetchMssqlApi } = fetchMSSQLHook();
  const [deletedVideos, setDeletedVideos] = useState([]);
  const [isChanged, setIsChanged] = useState(false);


  const handleVideoUpload = (e) => {
    setIsChanged(true);
    const file = e.target.files[0];
    const video = new Video(file, Date.now());
    const exceptions = new UploadExceptionList(file, videos);
    try {
      exceptions.checkExceptions()
      setVideos(prev => [...prev, video]);
    } catch (error) {
      console.error(error);
    }
    finally {
      inputRef.current.value = '';
    }
  }

  const handleVideoDelete = (video) => {
    setIsChanged(true);
    video.cleanup();
    setVideos(prev => prev.filter((v) => v.getId() !== video.getId()));
    if (video.uploaded) {
      setDeletedVideos(prev => [...prev, video.getVideoName()]);
    }
  }

  const getUploadedVideos = () => {
    fetchMssqlApi('/pax-video-uploading', {
      method: 'GET',
      hideNotification: true
    },
    (data) => {
      const videos = data.videos;
      if (!videos || !Array.isArray(videos)) {
        console.error('Invalid videos data received');
        NotificationManager.warning('Nie otrzymano prawidłowych danych filmików');
        return;
      }

      const processedVideos = [];
      
      if (videos.length === 0) {
        return
      }
      console.log(videos);
      videos.forEach((videoData, idx) => {
        try {
          // if (!videoData || !videoData.data) {
          //   console.error(`Invalid video data at index ${idx}:`, videoData);
          //   return;
          // }
          const mimeType = videoData.mimeType || 'video/mp4';
          
          let fileData;
          if (typeof videoData.data === 'string') {
            try {
              const byteCharacters = atob(videoData.data);
              const byteNumbers = new Array(byteCharacters.length);
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              fileData = new Uint8Array(byteNumbers);
            } catch (e) {
              console.error('Failed to decode base64 data:', e);
              return;
            }
          } else if (videoData.data instanceof ArrayBuffer || videoData.data instanceof Uint8Array) {
            fileData = videoData.data;
          } else {
            console.error('Unsupported video data format:', typeof videoData.data);
            return;
          }

          const fileName = videoData.name || videoData.fileName || `video_${idx + 1}.mp4`;
          const file = new File([fileData], fileName, { 
            type: mimeType,
            lastModified: videoData.lastModified || Date.now()
          });

          if (file.size === 0) {
            console.error(`Empty file created for video ${fileName}`);
            return;
          }

          const exceptions = new UploadExceptionList(file, processedVideos);
          try {
            exceptions.checkExceptions();
            const video = new Video(file, videoData.id || Date.now() + idx, true);
            processedVideos.push(video);
          } catch (validationError) {
            console.error(`Validation failed for ${fileName}:`, validationError.message);
          }
        } catch (error) {
          console.error(`Error processing video at index ${idx}:`, error);
        }
      });

      if (processedVideos.length > 0) {
        setVideos(prev => [...prev, ...processedVideos]);
      } else if (videos.length > 0) {
        NotificationManager.warning('Nie udało się załadować żadnych filmików z powodu błędów walidacji');
      }
    },
    (error) => {
      console.error('Error fetching videos:', error);
      NotificationManager.error('Nie udało się pobrać filmików');
    })
  }

  useEffect(() => {
    getUploadedVideos();
    
    return () => {
      videos.forEach(video => video.cleanup());
    };
  }, []);

  const deleteVideos = async () => {
    if (!deletedVideos.length) return;
    const videosToDelete = deletedVideos.map(video => fetchMssqlApi(`/pax-video-uploading/${video}`, {
      method: 'Delete',
      hideNotification: true
    }))
    return Promise.all(videosToDelete).then(
      () => setDeletedVideos([]),
      (error) => {
        console.error('Error deleting videos:', error);
        NotificationManager.error('Nie udało się usunąć filmików');
      }
    )
    
  }

  const handleSaveVideos = async () => {
    if (!isChanged) return;
    const data = new FormData();
    videos.forEach((video) => {
      const file = video.getFile();
      if (!video.uploaded) {
        data.append('files', file, file.name);
      }
    });
    if (videos.some(video => !video.uploaded)) {
      await fetchMssqlApi('/pax-video-uploading', {
        method: 'POST',
        data,
        hideNotification: true
      },
      () => {},
      () => {
        NotificationManager.error('Nie udało się zapisać filmików');
      })
    }

    await deleteVideos();
    setIsChanged(false);
  }
  const handleDeleteVideos = async () => {
    setDeletedVideos(videos.filter((uploaded) => uploaded).map(video => video.getVideoName()));
    await deleteVideos();
    setVideos([]);
    setIsChanged(false);
  }
  const uploadExceptionsDescription = new UploadExceptionList().uploadExceptionsDescription();

  return (
    <div className='container-fluid pax-video-uploader'>
      <div className='card'>
        <div className='card-header'>
          <h1>Pax screensaver</h1>
        </div>
        <div className='card-body'>
          <div className='upload-section'>
            <div className='row align-items-center'>
              <div className='col-md-6'>
                <h2>Wybierz filmiki</h2>
                <p className='text-muted mb-0'>Wybierz filmiki do przesłania. {uploadExceptionsDescription}</p>
              </div>
              <div className='col-md-6 d-flex justify-content-end'>
                <div>
                <div className='d-flex'>
                  <input 
                    type='file' 
                    className='d-none' 
                    id='video-uploader' 
                    onChange={handleVideoUpload} 
                    ref={inputRef}
                    accept="video/mp4,video/mov"
                  />
                  <label htmlFor='video-uploader' className='btn upload-button mr-3'>
                    <i className='fa fa-upload me-2'></i>   Wybierz
                  </label>
                  <label onClick={handleSaveVideos} className={`btn ${!isChanged && 'disabled'} save-button`}>
                    <i className='fa fa-save me-2'></i>   Zapisz
                  </label>
                </div>
                <div className='d-flex justify-content-center'>
                  <label onClick={handleDeleteVideos} className={`btn ${!videos.length && 'disabled'} delete-button`}>
                    <i className='fa fa-trash me-2'></i>   Usuń wszystkie
                  </label>
                </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className={`videos-grid ${videos.length === 0 ? 'empty' : ''}`}>
            {videos.length === 0 ? (
              <p>Nie ma jeszcze żadnych filmików. Kliknij &quot;Wybierz&quot; aby rozpocząć.</p>
            ) : (
              <div className='d-flex flex-wrap justify-content-center'>
                {videos.map((video) => (
                  <VideoContainer
                    key={video.getId()}
                    video={video}
                    onDelete={handleVideoDelete}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
